export enum LocalizationKeys {
    Available = 'OPS_Available',
    Busy = 'OPS_Busy',
    ConsumptionsPostponed = 'OPS_ConsumptionsPostponed',
    ConsumptionsWithDelay = 'OPS_ConsumptionsWithDelay',
    ConsumptionsWithoutDelay = 'OPS_ConsumptionsWithoutDelay',
    CraneTechnique = 'OPS_CraneTechnique',
    Deficit = 'OPS_Deficit',
    IncomeConsumptions = 'OPS_IncomeConsumptions',
    IncomeMtrSelector = 'OPS_IncomeMtrSelector',
    IncomeRelocations = 'OPS_IncomeRelocations',
    MeasureKgShort = 'OPS_MeasureKgShort',
    MeasureKtShort = 'OPS_MeasureKtShort',
    MeasureMtShort = 'OPS_MeasureMtShort',
    MeasureTnShort = 'OPS_MeasureTnShort',
    OutcomeConsumptions = 'OPS_OutcomeConsumptions',
    OutcomeMtrSelector = 'OPS_OutcomeMtrSelector',
    OutcomeRelocations = 'OPS_OutcomeRelocations',
    Proceeds = 'OPS_Proceeds',
    Requests = 'OPS_Requests',
    ScheduledForToday = 'OPS_ScheduledForToday',
    ScheduledForTomorrow = 'OPS_ScheduledForTomorrow',
    Shipping = 'OPS_Shipping',
    StorageResidues = 'OPS_StorageResidues',
    StorekeepersSelector = 'OPS_StorekeepersSelector',
    TechnicsSelector = 'OPS_TechnicsSelector',
    TileName = 'operational-plan-summary',
    Total = 'OPS_Total',
    TransportEquipment = 'OPS_TransportEquipment',
    OtherEmployersSelector = 'OPS_OtherEmployersSelector',
}
